import React from "react";
import { ToastContainer } from "react-toastify";
import LanguageSwitcher from "../components/GeneralComponents/LanguageSwitcher";
import { AuthLayoutProps } from "../types";
import { BASE_LOCAL_IMAGES_DIR } from "../utils/constants/CommonConstants";
import {
  authBg_IMG,
  loginBg_IMG,
  circlesPattern_IMG,
} from "../utils/constants/Images";

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="relative h-screen overflow-hidden ">
      <LanguageSwitcher />
      <div className="relative flex h-full items-center justify-between  overflow-clip">
        <div className="flex flex-col items-center w-1/2 ">{children}</div>
        <div className="bg-primaryMain h-full w-1/2 flex items-center justify-center">
          <img
            src={`${BASE_LOCAL_IMAGES_DIR}/${loginBg_IMG}`}
            className="w-[250px] object-cover 2xl:w-[450px]"
            alt="authBg"
            loading="lazy"
          />
          <img
            src={`${BASE_LOCAL_IMAGES_DIR}/${circlesPattern_IMG}`}
            className="absolute bottom-0 z-10 end-0 rtl:-end-5 rtl:rotate-90"
            alt="circlesPattern"
            loading="lazy"
          />
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};
export default AuthLayout;
